import { bizRequest } from '../../bizClient';

const getSublocations = async (customerId) =>
    await bizRequest(`/api/sublocations/getSublocationByCustomerId/${customerId}`);

const getSubLocationsByLocationId = async (locationId) =>
    await bizRequest(`/api/sublocations/location/${locationId}`);

const getSublocationsByPlaylistId = async (playlistId) =>
    await bizRequest(`/api/sublocations/playlist/${playlistId}`);

const createSublocation = async (sublocation) =>
    await bizRequest('/api/sublocations', 'POST', {}, sublocation);

const updateSublocation = async (sublocation) =>
    await bizRequest(`/api/sublocations/${sublocation.id}`, 'PUT', {}, sublocation);

const deleteSublocation = async (id) =>
    await bizRequest(`/api/sublocations/${id}`, 'DELETE');

const getRules = async (sublocationId) =>
    await bizRequest(`/api/sublocationRules/sublocation/${sublocationId}`);

const createRule = async (rule) =>
    await bizRequest('/api/sublocationRules', 'POST', {}, rule);

const updateRule = async (rule) =>
    await bizRequest(`/api/sublocationRules/${rule.id}`, 'PUT', {}, rule);

const deleteRule = async (id) =>
    await bizRequest(`/api/sublocationRules/remove/${id}`, 'GET');

export {
    getSublocations,
    getSubLocationsByLocationId,
    getSublocationsByPlaylistId,
    createSublocation,
    updateSublocation,
    deleteSublocation,
    getRules,
    createRule,
    updateRule,
    deleteRule,
};
